// AUTO-GENERATED SQL Builder (V40 Final) for LedgerEntry
import { 
  SqlField, 
  SqlExp, 
  SqlExpChain, 
  SqlFn, 
  SqlLiteral, 
  SqlSubQuery, 
  SqlApplyColumn, 
  SqlNavHybrid, 
  createNavHybrid 
} from '../utils/sql-core';
import { SqlAst } from '../utils/sql-ast';

export class LedgerEntrySql {
  private ast = new SqlAst('LedgerEntry', 'ledgerEntry');
  public readonly main: any = {};

  public guid: SqlField;
  public bookingId: SqlField;
  public guaranteeFundId: SqlField;
  public bookingPackageId: SqlField;
  public vendorId: SqlField;
  public entryType: SqlField;
  public amount: SqlField;
  public description: SqlField;
  public invoiceId: SqlField;
  public paymentId: SqlField;
  public entryDate: SqlField;
  public settled: SqlField;
  public bankRef: SqlField;
  public settledDate: SqlField;
  public direction: SqlField;
  public method: SqlField;
  public paymentTransferId: SqlField;
  public refundId: SqlField;
  public booking: SqlNavHybrid;
  public bookingPackage: SqlNavHybrid;
  public createdByUser: SqlNavHybrid;
  public guaranteeFund: SqlNavHybrid;
  public invoice: SqlNavHybrid;
  public payment: SqlNavHybrid;
  public updatedByUser: SqlNavHybrid;
  public vendor: SqlNavHybrid;
  public paymentTransfer: SqlNavHybrid;
  public refund: SqlNavHybrid;
  public id: SqlField;
  public isDeleted: SqlField;
  public createdBy: SqlField;
  public createdDate: SqlField;
  public updatedBy: SqlField;
  public updatedDate: SqlField;

  constructor() {
    this.guid = new SqlField('ledgerEntry', 'guid', '', 'id', 'ledgerEntry_guid');
    this.bookingId = new SqlField('ledgerEntry', 'bookingId', 'booking', 'id', 'ledgerEntry_booking');
    this.guaranteeFundId = new SqlField('ledgerEntry', 'guaranteeFundId', 'guaranteeFund', 'id', 'ledgerEntry_guaranteeFund');
    this.bookingPackageId = new SqlField('ledgerEntry', 'bookingPackageId', 'bookingPackage', 'id', 'ledgerEntry_bookingPackage');
    this.vendorId = new SqlField('ledgerEntry', 'vendorId', 'vendor', 'id', 'ledgerEntry_vendor');
    this.entryType = new SqlField('ledgerEntry', 'entryType', '', 'id', 'ledgerEntry_entryType');
    this.amount = new SqlField('ledgerEntry', 'amount', '', 'id', 'ledgerEntry_amount');
    this.description = new SqlField('ledgerEntry', 'description', '', 'id', 'ledgerEntry_description');
    this.invoiceId = new SqlField('ledgerEntry', 'invoiceId', 'invoice', 'id', 'ledgerEntry_invoice');
    this.paymentId = new SqlField('ledgerEntry', 'paymentId', 'payment', 'id', 'ledgerEntry_payment');
    this.entryDate = new SqlField('ledgerEntry', 'entryDate', '', 'id', 'ledgerEntry_entryDate');
    this.settled = new SqlField('ledgerEntry', 'settled', '', 'id', 'ledgerEntry_settled');
    this.bankRef = new SqlField('ledgerEntry', 'bankRef', '', 'id', 'ledgerEntry_bankRef');
    this.settledDate = new SqlField('ledgerEntry', 'settledDate', '', 'id', 'ledgerEntry_settledDate');
    this.direction = new SqlField('ledgerEntry', 'direction', '', 'id', 'ledgerEntry_direction');
    this.method = new SqlField('ledgerEntry', 'method', '', 'id', 'ledgerEntry_method');
    this.paymentTransferId = new SqlField('ledgerEntry', 'paymentTransferId', 'paymentTransfer', 'id', 'ledgerEntry_paymentTransfer');
    this.refundId = new SqlField('ledgerEntry', 'refundId', 'refund', 'id', 'ledgerEntry_refund');
    this.booking = createNavHybrid('ledgerEntry', 'ledgerEntry_booking', 'Booking');
    this.bookingPackage = createNavHybrid('ledgerEntry', 'ledgerEntry_bookingPackage', 'BookingPackage');
    this.createdByUser = createNavHybrid('ledgerEntry', 'ledgerEntry_createdByUser', 'User');
    this.guaranteeFund = createNavHybrid('ledgerEntry', 'ledgerEntry_guaranteeFund', 'GuaranteeFund');
    this.invoice = createNavHybrid('ledgerEntry', 'ledgerEntry_invoice', 'Invoice');
    this.payment = createNavHybrid('ledgerEntry', 'ledgerEntry_payment', 'Payment');
    this.updatedByUser = createNavHybrid('ledgerEntry', 'ledgerEntry_updatedByUser', 'User');
    this.vendor = createNavHybrid('ledgerEntry', 'ledgerEntry_vendor', 'Vendor');
    this.paymentTransfer = createNavHybrid('ledgerEntry', 'ledgerEntry_paymentTransfer', 'PaymentTransfer');
    this.refund = createNavHybrid('ledgerEntry', 'ledgerEntry_refund', 'Refund');
    this.id = new SqlField('ledgerEntry', 'id', '', 'id', 'ledgerEntry_id');
    this.isDeleted = new SqlField('ledgerEntry', 'isDeleted', '', 'id', 'ledgerEntry_isDeleted');
    this.createdBy = new SqlField('ledgerEntry', 'createdBy', '', 'id', 'ledgerEntry_createdBy');
    this.createdDate = new SqlField('ledgerEntry', 'createdDate', '', 'id', 'ledgerEntry_createdDate');
    this.updatedBy = new SqlField('ledgerEntry', 'updatedBy', '', 'id', 'ledgerEntry_updatedBy');
    this.updatedDate = new SqlField('ledgerEntry', 'updatedDate', '', 'id', 'ledgerEntry_updatedDate');

    for (const k of Object.keys(this)) {
      const v = (this as any)[k];
      if (v instanceof SqlField) this.main[k] = v;
    }
  }

  // SELECT
  select(fn:(x:LedgerEntrySql)=>any) {
    this.ast.addSelectObject(fn(this));
    return this;
  }

  // WHERE
  where(fn:(x:LedgerEntrySql)=>SqlExp | SqlExpChain) {
    this.ast.addWhere(fn(this));
    return this;
  }
  and(fn:(x:LedgerEntrySql)=>SqlExp | SqlExpChain) {
    this.ast.addWhere(fn(this));
    return this;
  }
  or(fn:(x:LedgerEntrySql)=>SqlExp | SqlExpChain) {
    this.ast.addOr(fn(this));
    return this;
  }

  // JOIN
  join(fn:(x:LedgerEntrySql)=>SqlField | SqlNavHybrid) {
    const f = fn(this);
    this.ast.addJoin(f instanceof SqlNavHybrid ? f.asSqlField() : f);
    return this;
  }
  leftJoin(fn:(x:LedgerEntrySql)=>SqlField | SqlNavHybrid) {
    const f = fn(this);
    this.ast.addJoin(f instanceof SqlNavHybrid ? f.asSqlField() : f, 'LEFT');
    return this;
  }
  rightJoin(fn:(x:LedgerEntrySql)=>SqlField | SqlNavHybrid) {
    const f = fn(this);
    this.ast.addJoin(f instanceof SqlNavHybrid ? f.asSqlField() : f, 'RIGHT');
    return this;
  }

  // AND JOIN
  andJoin(fn:(l:any,r:any)=>SqlExp | SqlExpChain) {
    const last = this.ast.joins[this.ast.joins.length - 1];
    if (!last) throw new Error('andJoin() before join()');

    const left = new Proxy({}, {
      get:(_,prop:string)=> new SqlField(this.ast.alias, prop)
    });
    const right = new Proxy({}, {
      get:(_,prop:string)=> new SqlField(last.alias, prop)
    });

    const exp = (this.ast as any).compileExp(fn(left, right));

    if (typeof last.on === 'string') {
      last.on = {
        logic:'And', isTrusted:false,
        subFilters:[
          { column:last.on, operator:'', value:null, isTrusted:true, subFilters:[] },
          exp
        ]
      };
    }
    else if (last.on.logic === 'And') {
      last.on.subFilters.push(exp);
    }
    else {
      last.on = {
        logic:'And', isTrusted:false,
        subFilters:[ last.on, exp ]
      };
    }

    return this;
  }

  // CTE
  with(name:string, fn:(c:any)=>any) {
    this.ast.with(name, fn);
    return this;
  }
  withRecursive(name:string, fn:(c:any)=>any) {
    this.ast.withRecursive(name, fn);
    return this;
  }

  // CTE JOIN
  joinCTE(name:string, alias:string, fn:(l:any,r:any)=>SqlExp | SqlExpChain) {
    this.ast.joinCTE(name, alias, fn);
    return this;
  }
  fullJoinCTE(name:string, alias:string, fn:(l:any,r:any)=>SqlExp | SqlExpChain) {
    this.ast.fullJoinCTE(name, alias, fn);
    return this;
  }

  // SUBQUERY
  subQuery(fn:(b:any)=>any) {
    return new SqlSubQuery(fn);
  }

  // APPLY
  apply(name:string, fn:(b:any)=>any) {
    this.ast.apply(name, fn);
    return this;
  }
  applyColumn(name:string, fn:(b:any)=>SqlField) {
    return this.ast.applyColumn(name, fn);
  }
  crossApply(app:any) {
    this.ast.crossApply(app);
    return this;
  }

  // GROUP BY
  groupBy(fn:(x:LedgerEntrySql)=>SqlField[]) {
    this.ast.addGroup(fn(this));
    return this;
  }

  // HAVING
  having(fn:(x:LedgerEntrySql)=>SqlExp | SqlExpChain) {
    this.ast.addHaving(fn(this));
    return this;
  }

  // ORDER
  orderBy(fn:(x:LedgerEntrySql)=>any[]) {
    this.ast.addOrder(fn(this));
    return this;
  }

  // UNION
  union(fn:(q:any)=>any) {
    this.ast.union(fn);
    return this;
  }
  unionAll(fn:(q:any)=>any) {
    this.ast.unionAll(fn);
    return this;
  }

  limit(n:number) { this.ast.take = n; return this; }
  offset(n:number) { this.ast.skip = n; return this; }

  build() {
    return this.ast.toQueryDescriptor();
  }
}
